import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from './cn.js';
const toneClass = {
    primary: 'bg-primary',
    success: 'bg-success',
    destructive: 'bg-destructive',
    warning: 'bg-warning-text',
};
/**
 * A 6 px bar for a firmware deployment, a bulk import, or the commissioning
 * flow's completeness. Give it a label with the count beside it; never a
 * percentage without a count.
 */
const Progress = React.forwardRef(({ className, value = 0, max = 100, tone = 'primary', indeterminate = false, label, detail, ...props }, ref) => {
    const percent = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
    const bar = (_jsx(ProgressPrimitive.Root, { ref: ref, "data-slot": "progress", value: indeterminate ? null : value, max: max, className: cn('relative h-1.5 w-full overflow-hidden rounded-full bg-muted', label == null && detail == null && className), ...props, children: _jsx(ProgressPrimitive.Indicator, { className: cn('h-full rounded-full transition-[width] duration-(--duration-slow) ease-standard', toneClass[tone], indeterminate && 'w-2/5 animate-progress-indeterminate'), style: indeterminate ? undefined : { width: `${percent}%` } }) }));
    if (label == null && detail == null)
        return bar;
    return (_jsxs("div", { className: cn('flex flex-col gap-1.5', className), children: [_jsxs("div", { className: "flex items-baseline justify-between gap-3 text-caption", children: [_jsx("span", { className: "text-foreground", children: label }), detail != null && _jsx("span", { className: "text-muted-foreground tnum", children: detail })] }), bar] }));
});
Progress.displayName = 'Progress';
export { Progress };
//# sourceMappingURL=progress.js.map